import React, { lazy, Suspense } from 'react';
import PrivateRoute from "../../routes/PrivateRoute";
import PublicRoute from "../../routes/PublicRoute";
import { Spinner } from '../Common/Spinner';
const SupplierListTable = lazy(() => import('./List/SupplierListTable'));
const SupplierForm = lazy(() => import('./SupplierForm'));
const SupplierProfilePage = lazy(() => import('./SupplierProfilePage'));

const SuppliersRouter = (props) => (
  <Suspense fallback={<Spinner />}>
    <PrivateRoute path="/list/suppliers" searchString={props.searchString} component={SupplierListTable} exact />
    <PrivateRoute path="/supplier/profile/:id" component={SupplierProfilePage} exact />
    <PublicRoute path="/supplier/:id?" component={SupplierForm} exact />
  </Suspense>
)

export default SuppliersRouter;